module.exports = __webpack_public_path__ + "static/media/file-gif.e4bb3252.svg";